module.exports = __webpack_public_path__ + "img/trade-federation.a1f1d66b.svg";